import React from 'react';
import {
  ButtonVariant, Icon, IconName,
} from '@usealloy/component-library';
import { StyledSearchTrigger, StyledTooltip } from './styles';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectIsSearchBoxVisible } from 'flow/store/redux/selectors';
import { setIsSearchBoxVisible } from 'flow/store/redux/slice';
import { useKeyboardKeyEvent } from 'flow/editor/hooks/useKeyboardKeyEvent';
import { closeSearchBoxThunk } from 'flow/store/redux/thunks';
import { getBrowserOS } from 'flow/service/util';
import { dismissShortcut, nodeSearchShortcut } from 'flow/editor/hooks/useKeyboardKeyEvent/constants';

export default function SearchTrigger({
  variant = ButtonVariant.secondary,
}: {
  variant?: ButtonVariant;
}) {
  const dispatch = useAppDispatch();

  const isSearchBoxVisible = useAppSelector(selectIsSearchBoxVisible);
  const browserOS = getBrowserOS();

  const openSearchBox = () => {
    if (!isSearchBoxVisible) {
      dispatch(setIsSearchBoxVisible(true));
    }
  };

  const closeSearchBox = () => dispatch(closeSearchBoxThunk());

  useKeyboardKeyEvent({
    shortcut: nodeSearchShortcut,
    callback: event => {
      // prevent the browser's search box from appearing
      event.preventDefault();
      openSearchBox();
    },
  });

  useKeyboardKeyEvent({
    enabled: isSearchBoxVisible,
    shortcut: dismissShortcut,
    callback: closeSearchBox,
  });

  const keyboardHintText = browserOS === 'mac' ? '(cmd + F)' : '(ctrl + F)';
  return (
    <StyledTooltip
      content={<>Search this Workflow<br />{keyboardHintText}</>}
    >
      <StyledSearchTrigger variant={variant} onClick={openSearchBox}>
        <Icon icon={IconName.Search} />
      </StyledSearchTrigger>
    </StyledTooltip>
  );
}
